function UIDropdown() {
  $(".ui.dropdown").dropdown();
}

function UIModal() {
  $(".js-modal-btn").on("click", function() {
    var target = $(this).data("target");
    $(target).modal("show");
  });
}

function editAddress() {
  $(".js-edit-address-btn").on("click", function() {
    $(".js-edit-address-modal")
      .modal({
        blurring: true
      })
      .modal("show");
  });
}

function addaddress() {
  $(".js-add-address").accordion({
    selector: {
      trigger: ".title"
    }
  });
}
function sideBar() {
  $(".js-accordion").accordion({
    selector: {
      trigger: ".title"
    }
  });
}
function UIcheckbox() {
  $(".ui.checkbox").checkbox();
}
// function datePickerBirth() {
//     $('.js-birthdate').calendar({
//         type: 'date'
//     });
// }

function clickadditem() {
  var price = $(".js-price").text();
  var price_number = Number(price.replace(/[^0-9.-]+/g, ""));

  $(".js-increseItem").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get its current value
    var currentVal = parseInt(
      $(this)
        .parent()
        .find(".js-itemAmount")
        .val()
    );
    // If is not undefined
    console.log(price_number);
    if (!isNaN(currentVal)) {
      // Increment only if value is < 20
      if (currentVal < 20) {
        $(this)
          .parent()
          .find(".js-itemAmount")
          .val(currentVal + 1);
        $(this)
          .parent()
          .find(".js-decreseItem")
          .removeAttr("style");
        var new_price = price_number * (currentVal + 1);
        var new_price_number = new_price
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $(".js-price").text(new_price_number);
      } else {
        $(this)
          .val("+")
          .css("color", "#aaa");
        $(this)
          .val("+")
          .css("cursor", "not-allowed");
      }
    } else {
      // Otherwise put a 0 there
      $(this)
        .parent()
        .find(".js-itemAmount")
        .val(1);
    }
  });
  $(".js-decreseItem").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get its current value
    var currentVal = parseInt(
      $(this)
        .parent()
        .find(".js-itemAmount")
        .val()
    );
    // If is not undefined
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one only if value is > 1
      $(this)
        .parent()
        .find(".js-itemAmount")
        .val(currentVal - 1);
      $(this)
        .parent()
        .find(".js-increseItem")
        .removeAttr("style");
      var new_price = price_number * (currentVal - 1);
      var new_price_number = new_price
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(".js-price").text(new_price_number);
    } else {
      // Otherwise put a 0 there
      $(this)
        .parent()
        .find(".js-itemAmount")
        .val(0);
      $(this).css("color", "#aaa");
      $(this).css("cursor", "not-allowed");
    }
  });
}

function paymentTab() {
  $(".js-tabs .item").tab();
}

function productAlign() {
  $(".js-product-align-column").click(function() {
    $(".type-f").addClass("[ align-column ]");
    $(this).addClass("active");
    $(".js-product-align-horizontal").removeClass("active");
  });
  $(".js-product-align-horizontal").click(function() {
    $(".type-f").removeClass("[ align-column ]");
    $(this).addClass("active");
    $(".js-product-align-column").removeClass("active");
  });
}

function UItab() {
  $(".js-tab .item").tab();
}
$(window).on("load", function() {
  // --------------------------------- //
  sideBar();

  clickadditem();
  addaddress();
  paymentTab();
  // datePickerBirth();
  editAddress();
  UIModal();
  UIcheckbox();
  UIDropdown();
  productAlign();
  UItab();

  // $('.js-gallery-thumb').slick({
  //     asNavFor: '.js-gallery-main',
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: false,
  //     infinite: false,
  //     focusOnSelect: true
  // });
  // $('.js-gallery-main').slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: true,
  //     infinite: false,
  //     accessibility: false,
  // });

  // zoomImage();
  // $(".js-gallery-main").on("afterChange", function(
  //   event,
  //   slick,
  //   currentSlide,
  //   nextSlide
  // ) {
  //   $(".zoomContainer").remove();
  //   zoomImage();
  // });
});
$(document).ready(function() {});
$(window).on("load resize orientationchange", function() {
  $(".products-list.set-1").each(function() {
    var $carousel = $(this);
    if ($(window).width() > 992) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
  $(".products-list.set-2").each(function() {
    var $carousel = $(this);
    if ($(window).width() > 992) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
  $(".products-list.set-3").each(function() {
    var $carousel = $(this);
    if ($(window).width() > 992) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 2,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
  $(".products-list.set-4").each(function() {
    var $carousel = $(this);
    if ($(window).width() > 1200) {
      if ($carousel.hasClass("slick-initialized")) {
        $carousel.slick("unslick");
      }
    } else {
      if (!$carousel.hasClass("slick-initialized")) {
        $carousel.slick({
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 720,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
});
